import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
const faqs: {
  q: string;
  a: string;
}[] = [{
  q: '«Ya compré un curso y no me sirvió.»',
  a: 'Por eso esto no es un curso. Los cursos enseñan teoría; esto es el manual de operaciones que usarías si trabajaras dentro de una agencia top. No hay clases, no hay horarios, no hay módulos que abandonas en la semana dos. Hay sistema: abres el tomo, copias el guion, lo usas hoy.'
}, {
  q: '«Eso lo puedo aprender gratis en YouTube.»',
  a: 'Gratis consigues piezas sueltas, repartidas en 500 reels, casi todas pensadas para el mercado de Estados Unidos. Lo que no existe gratis es el sistema completo y ordenado, adaptado a cómo se venden bodas en español — donde el contrato se cierra por WhatsApp y las decisiones las toman dos familias.'
}, {
  q: '«¿Funciona en mi país?»',
  a: 'Sí. Cambian las monedas, los proveedores y los portales; los sistemas no. Posicionamiento, cierre por WhatsApp, seguimiento, recomendación, finanzas y captación funcionan igual en México, Colombia, Argentina, Chile, Perú, República Dominicana o España.'
}, {
  q: '«En mi ciudad ya hay muchísimas wedding planners.»',
  a: 'Exacto: por eso ninguna puede subir sus precios. Todas ofrecen lo mismo, de la misma forma, en el mismo directorio. El Tomo 1 existe para sacarte de esa lista, y el Tomo 6 para que dejes de depender de ella.'
}, {
  q: '«No tengo experiencia ni portafolio.»',
  a: 'El sistema es la experiencia: son los procesos de agencias que ya cometieron todos los errores caros. Los instalas en semanas en lugar de aprenderlos en años de prueba y error sobre bodas reales.'
}, {
  q: '«No tengo dinero para invertir.»',
  a: 'Cuesta menos que lo que pierdes en una sola boda cobrada a precio de amiga. Y menos que la cuota anual del portal que hoy te manda parejas que solo preguntan precio.'
}, {
  q: '«No tengo tiempo para otro curso.»',
  a: 'No son clases. Es material de consulta: abres el tomo que resuelve el problema que tienes hoy. ¿Te dejaron en visto? Tomo 3. ¿Te piden descuento? Bono 1. Cinco minutos, no cinco semanas.'
}, {
  q: '«¿Y si no es para mí?»',
  a: 'Garantía de 7 días. Devolución del 100%, sin preguntas y sin formularios.'
}];
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="w-full bg-white py-16 sm:py-24" data-id="element-99" data-mp="2dexhwsvlh4wt">
      <div className="mx-auto max-w-3xl px-5" data-id="element-100" data-mp="28gcg4p0p2d69">
        <h2 className="text-center font-serif text-3xl sm:text-5xl text-ink" data-id="element-101" data-mp="28hf8l1do0noa">
          Lo que ya estás pensando
        </h2>
        <div className="rule-gold mx-auto mt-8 w-32" aria-hidden="true" data-id="element-102" data-mp="1zfxs3hwcijz2" />

        <ul className="mt-12 divide-y divide-gold-soft/70 border-y border-gold-soft/70" data-id="element-103" data-mp="1zi0hbzpoc92q">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.q} data-id="element-104" data-mp="o2vbwny5rwff" data-mpi={index}>
                <h3 data-id="element-105" data-mp="2zoe0scc4rcaf">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 py-6 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-gold/50" data-id="element-106" data-mp="2zox9d2fw4obs">
                    <span className="font-serif text-lg sm:text-xl text-ink" data-id="element-107" data-mp="3dhdh2gjqlaj1">{faq.q}</span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-gold-dark transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-108" data-mp="3igq3j06p4fl3" />
                  </button>
                </h3>
                <AnimatePresence initial={false} data-id="element-109" data-mp="1x1ivfp1spoqn">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.28,
                ease: [0.4, 0, 0.2, 1]
              }} className="overflow-hidden" data-id="element-110" data-mp="220dn7ghqqnmw">
                      <p className="pb-7 pr-10 text-[15px] leading-relaxed text-ink-soft" data-id="element-111" data-mp="1gnuxvvu2hp00">
                        {faq.a}
                      </p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}